<template>
  <div>
    <h3>REPORTE</h3>
    <div class="row">
      <div class="col">
        <app-datepicker v-model="date" @input="getReport()"></app-datepicker>
      </div>
      <div class="col">
        <SelectEntity v-model="entityId" @input="getReport()"></SelectEntity>
      </div>
    </div>
    <table class="table table-sm table-bordered mt-3">
      <tr>
        <th>CATEGORIA</th>
        <th>PRODUCTO</th>
        <th>MESA</th>
        <th>LLEVAR</th>
        <th>DELIVERY</th>
        <th>CANTIDAD</th>
        <!--<th>POLLOS</th>-->
      </tr>
      <template v-for="(l1, i1) in groups">
        <tr v-for="(l, i) in l1" :key="i + '-' + i1">
          <td :rowspan="l1.length" v-show="i == 0">{{ l.categorie }}</td>
          <td>{{ l.product_name }}</td>
          <td class="text-center">{{ l.quantity_sold }}</td>
          <td class="text-center">{{ l.quantity_delivered }}</td>
          <td class="text-center">{{ l.quantity_delivery }}</td>
          <td class="text-center">{{ l.quantity }}</td>
          <!--<td class="text-center">{{ l.chicken }}</td>-->
        </tr>
        <tr :key="i1">
          <th class="text-right" colspan="2">SUB TOTAL</th>
          <td class="text-center">{{ l1 | sumColumn("quantity_sold") }}</td>
          <td class="text-center">
            {{ l1 | sumColumn("quantity_delivered") }}
          </td>
          <td class="text-center">{{ l1 | sumColumn("quantity_delivery") }}</td>
          <td class="text-center">{{ l1 | sumColumn("quantity") }}</td>
          <!--<td class="text-center table-warning">-->
          <!--{{ l1 | sumColumn("chicken") }}-->
          <!--</td>-->
        </tr>
      </template>
      <!--<tr>-->
      <!--<th class="text-right" colspan="6">TOTAL</th>-->
      <!--<td class="text-center table-info">-->
      <!--{{ list | sumColumn("chicken") }}-->
      <!--</td>-->
      <!--</tr>-->
    </table>

    <!-- <div class="row">
      <div class="col">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">Resto</span>
          </div>
          <input
            type="number"
            step="0.001"
            class="form-control"
            v-model="residue"
            :disabled="saved"
          />
          <div class="input-group-prepend">
            <span class="input-group-text">Comprado</span>
          </div>
          <input
            type="number"
            step="0.001"
            class="form-control"
            v-model="purchased"
            :disabled="saved"
          />
          <div class="input-group-prepend">
            <span class="input-group-text">Consumido</span>
          </div>
          <input
            type="number"
            step="0.001"
            class="form-control"
            v-model="used"
            :disabled="saved"
          />
        </div>
        <app-button-submit v-show="!saved" @oneClick="save"></app-button-submit>
      </div>
    </div> -->

    <!-- <button class="btn btn-primary" @click="$refs.elModLog.show()">verlog</button> -->
    <!--
    <app-modal-basic ref="elModLog">
      <LogisticControl :entityId="entityId"></LogisticControl>
    </app-modal-basic> -->
  </div>
</template>
<script>
import { myMoment } from "src/lt-module/utils/myMoment.js";
import { DinnerService } from "./DinnerService.js";
import _ from "lodash";
import SelectEntity from "src/lt-module/admin-module/entitys/Select.vue";
// import LogisticControl from "./LogisticControl.vue";

export default {
  components: {
    SelectEntity
    // LogisticControl
  },

  // directives

  filters: {
    sumColumn: function(row = [], prop) {
      return row.map((x) => parseFloat(x[prop])).reduce((p, c) => p + c, 0);
    }
  },

  props: {
    //
  },

  data: () => ({
    date: myMoment().format("YYYY-MM-DD"),
    entityId: 1,
    list: [],
    groups: [],

    // chicken
    saved: false,
    residue: 0, // resto de las ultimas actividades - ayer
    purchased: 0, // comprado
    used: 0 // usado
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    this.getReport();
    this.entityId = 1;
  },

  methods: {
    save() {
      //
      DinnerService.saveChicken(this.date, this.entityId, 11);
    },
    getReport() {
      this.list = [];
      DinnerService.getReport(this.date, this.entityId).then((data) => {
        this.list = data;
        this.groups = _.groupBy(data, "categorie");
        // for (let it in this.groups) {
        //   console.log(it);
        // }

        // chicken
        // DinnerService.getChicken(this.date, this.entityId).then(
        //   res => {
        //     this.saved = res.saved;
        //     this.residue = res.residue;
        //     this.purchased = res.purchased;
        //     this.used = res.used;
        //   },
        //   () => {
        //     this.saved = false;
        //   }
        // );
      });
    }
  }
};
</script>

<style scoped></style>
